var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaLotus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0253 18.1749C14.8258 17.2045 13.8482 15.9884 13.1582 14.6085C12.4682 13.2285 12.0819 11.7167 12.0253 10.1749C12.0631 8.78473 12.3755 7.41573 12.9443 6.14667C13.5132 4.87762 14.3273 3.73355 15.3399 2.78026C15.5231 2.6007 15.7694 2.50012 16.0259 2.50012C16.2825 2.50012 16.5287 2.6007 16.7119 2.78026C17.7241 3.73384 18.5378 4.878 19.1064 6.14701C19.675 7.41602 19.9873 8.78487 20.0253 10.1749C19.9686 11.7167 19.5823 13.2285 18.8924 14.6085C18.2024 15.9884 17.2247 17.2045 16.0253 18.1749V18.1749Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9199 8.77478C21.8301 7.47555 24.0898 6.78696 26.3999 6.80011C26.6633 6.80046 26.9158 6.90496 27.1024 7.09081C27.289 7.27665 27.3945 7.52876 27.3959 7.79211C27.4354 9.17862 27.2009 10.5593 26.7058 11.855C26.2106 13.1507 25.4647 14.3359 24.5106 15.3428C23.3803 16.3929 22.0381 17.1886 20.5744 17.6765C19.1108 18.1643 17.5596 18.3328 16.0253 18.1708",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1335 8.78922C10.2127 7.46884 7.93094 6.77406 5.60022 6.79989C5.3365 6.79988 5.08349 6.90418 4.8964 7.09003C4.7093 7.27588 4.60331 7.52818 4.60155 7.79189C4.561 9.17879 4.79465 10.5601 5.28909 11.8565C5.78354 13.1529 6.52905 14.3389 7.48288 15.3466C8.62377 16.3984 9.97591 17.1947 11.449 17.6824C12.9222 18.1701 14.4824 18.3378 16.0255 18.1746",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19.5C26 22.2613 21.5227 24.5 16 24.5C10.4773 24.5 6 22.2667 6 19.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7466 15.4961C30.5483 16.6772 30.9833 18.0687 30.9973 19.4961C30.9973 25.0188 24.2813 29.4961 15.9973 29.4961C7.71331 29.4961 0.997314 25.0228 0.997314 19.5001C1.01066 18.073 1.44479 16.6816 2.24531 15.5001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaLotus);
export default __webpack_public_path__ + "static/media/SpaLotus.8de967b3220e8ee02625879b69ec16a6.svg";
export { ForwardRef as ReactComponent };